// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1vbDg","loaderOuter":"PageOverlayLoader_loaderOuter__pRvKZ"};